import BuiltForCreators from "@/components/creatorshield/BuiltForCreators";
import FAQ from "@/components/creatorshield/FAQ";
import FinalCTA from "@/components/creatorshield/FinalCTA";
import Footer from "@/components/creatorshield/Footer";
import FullFinancialControl from "@/components/creatorshield/FullFinancialControl";
import Header from "@/components/creatorshield/live/Header";
import WhatWeProtect from "@/components/creatorshield/live/WhatWeProtect";
import SocialProof from "@/components/creatorshield/SocialProof";
import scrollTo from "@/utils/scrollTo";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function CreatorshieldLive() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollTo(location.state.scrollTo);
        window.history.replaceState({}, document.title);
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <div>
      <Header />
      <WhatWeProtect />
      <BuiltForCreators />
      <SocialProof />
      <FullFinancialControl />
      <FinalCTA />
      <FAQ />
      <Footer />
    </div>
  );
}
